import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { env } from "@environments/environment";
import { Observable } from "rxjs";
import { DistributionDocument } from "@app/ui_models/document.service.models";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class DocumentsController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;
  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/document`;

  public createFileInDocument(file: DistributionDocument): Observable<any> {
    const headers = new HttpHeaders().set("Content-type", "application/json");
    return this.httpService.post(`${this.baseUrl}/create`,
      JSON.stringify(file),
      { headers, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getAllForDistribution(distributionId: number): Observable<DistributionDocument[]> {
    return this.httpService.get(`${this.baseUrl}/all/${distributionId}`, { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }
}
